import { useEffect } from 'react';

let lockCount = 0;
let originalBodyOverflow = '';

const useLockBodyScroll = (locked = true) => {
  useEffect(() => {
    if (!locked) return;

    if (lockCount === 0) {
      originalBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
    lockCount += 1;

    return () => {
      lockCount -= 1;
      if (lockCount === 0) {
        document.body.style.overflow = originalBodyOverflow;
        document.documentElement.style.overflow = '';
      }
    };
  }, [locked]);
};

export default useLockBodyScroll;
